<template>
  <v-app>
    <!--   own numbers-->
    <v-dialog
        v-model="infos"
        persistent
        max-width="800px"
    >
      <template v-slot:activator="{ on, attrs }">
      </template>
      <v-card>
        <v-toolbar
            flat
            dark
            color="primary"
        >

          <v-toolbar-title>شماره های تعرفه</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
                icon
                dark
                @click="infos = false ; uniquePack = ''"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <show-own-num v-if="infos" :modal="()=>{this.infos=false}" :uniquePack="uniquePack"></show-own-num>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--        own numbers-->
    <div class="pt-5 mt-5">
      <div class="px-5 mt-5 pt-5">
        <v-card :loading="loading" class="p-3 pt-0">
          <terminal-table class="col-12" :currentPage="data.current_page"
                          :perPage="data.per_page" v-if="isMobile" :getData="getDataForTable"
                          :pageCount="data.last_page"
                          :options="tableProps" :datas="data" :headers="columns"></terminal-table>
          <data-table
              v-else
              :data="data"
              :columns="columns"
              :debounce-delay="3000"
              :translate="translate"
              :per-page="[10, 25, 50, 100, 500]"
              @on-table-props-changed="reloadTable"
              :orderBy="tableProps.column"
              :pagination="paginate"
              :orderDir="tableProps.dir"
              :loading="true"
              class="pt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
          >
            <template slot="filters" slot-scope="{ tableFilters, perPage }">
              <filters-table @getInfo="(val)=>{ if (val) tableProps.search = searchBox.search }"
                             v-model="searchBox"></filters-table>
            </template>
          </data-table>
        </v-card>
      </div>
    </div>
  </v-app>
</template>
<script>
import {dataTableProps} from "@/main";
import button from "@/view/pages/button";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import ShowOwnNum from "@/view/pages/monitoring/showOwnNum";
import {debounce} from "../../../custom";
import buttonTempl from "@/view/pages/uiBeautifier/buttonTempl";
import FiltersTable from "@/components/Table/filtersTable";

export default {
  name: "numberMonitoring",
  components: {FiltersTable, ShowOwnNum, TitleRibbon},
  data() {
    return {
      infos: false,
      loading: false,
      translate: dataTableProps.translate,
      tableProps: dataTableProps.tableProps,
      paginate: dataTableProps.pagination,
      groupModal: false,
      chargeMount: '',
      uniquePack: '',
      selectedNumber: '',
      numbersInfo: false,
      dataId: '',
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          isCheckBox: true,
          transform: (val) => {
            return `<input type="checkbox"  data-id="${val.data.unique}">`
          },
          orderable: false,
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          searchable: true,
        },
        {
          label: 'کاربر',
          name: 'user.name',
          primary: true,
          transform(val) {
            return val.data.user.name + ' ' + val.data.user.lastName
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'بسته',
          name: 'number_pack',
          transform: (val) => {
            return val.data.number_pack ? val.data.number_pack : 'وجود ندارد';
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'تعداد خط',
          name: 'total_number',
          transform: (val) => {
            return val.data.total_number ? val.data.total_number : '-';
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'زمان خرید',
          name: 'created_at_p',
          orderable: true,
          searchable: true,
        },
        {
          label: 'زمان انقضا',
          name: 'expire_at_p',
          orderable: true,
          searchable: true,
        },
        {
          label: 'روزهای باقی مانده',
          name: 'expire_at_diff',
          primary: true,
          transform(val) {
            const color = val.data.expire_at_diff == '3 روز دیگر' ? 'orange' : 'green';
            return `
                        <span title="${val.data.expire_at_p}" class="badge text-white" style="background-color: ${val.data.deleted_at === "حذف شده" ? 'red' : color}">${val.data.expire_at_diff}</span>`
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'مدیریت',
          name: 'action',
          component: button,
          handler: this.actions,
          event: "actions",
          meta: {
            buttons: [
              {
                name: 'delete',
                label: 'حذف بسته',
                icon: 'trash-alt',
                class: 'btn-outline-danger',
                action: this.actions,
                status: 'divar_delete',
                condition: this.buttonsCondition
              },
              {
                name: 'login',
                label: 'مشاهده شماره ها',
                icon: 'eye',
                class: 'btn-outline-primary',
                action: this.actions,
                condition(status) {
                  return true;
                }
              },
            ]
          }
        }

      ],
      data: {},
      url: `${url}/admin/monitoring/packs`,
      searchBox: {
        search: '',
        length: 10
      },
    }
  },
  methods: {
    getDataForTable(url = this.url, query = this.tableProps) {
      const vm = this;
      vm.loading = true;
      $.ajax({
        url: url,
        type: 'GET',
        fn: this.getDataForTable,
        data: Object.assign({}, query, {search:this.tableProps.search,length:this.searchBox.length}),
        headers: {
          "ACCEPT": "application/json",
          "Authorization": Token
        },
        success: function (data) {
          vm.data = data.data;
          vm.loading = false;
        }
      })
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.getDataForTable(this.url, tableProps);
      }, 700);
    },
    showData(value) {
      this.infos = true;
      this.uniquePack = value
    },
    buttonsCondition(status) {
      return [
        "حذف شده",
      ].indexOf(status) <= -1;
    },
    actions(data, type) {
      if (type === 'delete') {
        this.uniquePack = data.uniq
        this.$modal.yesNo("تایید حذف!", "آیا از حذف این بسته اطمینان دارید؟").then((value) => {
          if (value === true)
            $.ajax({
              url: `${url}/admin/monitoring/packs/${this.uniquePack}`,
              method: "DELETE",
              headers: {
                'Authorization': Token,
                ACCEPT: 'application/json',
                "Content-Type": "application/json"
              },
              msg: true,
              success: () => {
                this.reloadTable();
              }
            })
        })
      } else if (type === 'login') {
        this.uniquePack = data.uniq;
        this.infos = true;
      }
    },
  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          this.getDataForTable(this.url);
          return true
        case 'sm':
          this.getDataForTable(this.url);
          return true
        case 'md':
          this.getDataForTable(this.url);
          return false
        case 'lg':
          this.getDataForTable(this.url);
          return false
        case 'xl':
          this.getDataForTable(this.url);
          return false
      }
    },
  },
  watch: {
    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox.length;
      },
      deep: true
    }
  },
  mounted() {
    this.tableProps = {
      search: '',
      length: 10,
      column: 'id',
      dir: 'desc',
      page: 1,
    };
    this.getDataForTable(this.url)

    $(document).on('click', '#selectAll', (element) => {
      if ($(element.target).is(':checked')) {
        $('input[type="checkbox"]').prop('checked', true);

        const selected = $('input[type="checkbox"]').map(function () {
          return $(this).data('id')
        }).get();

        this.selectedNumber = selected;
      } else {
        $('input[type="checkbox"]').prop('checked', false)
        this.selectedNumber = []
      }
    })
  },
}
</script>

<style scoped>

</style>